<app-site-selector
  #siteSelector
  [ctx]="ctx"
  (selectionChange)="onSiteSelectionChanged()"
  [showTags]="ctx != ADMIN_CONTEXT"
  [canAutoRefresh]="true"
  [minDateDays]="90"
  [maxSpan]="moment.duration(1, 'month')"
  [ranges]="['15M', '1H', '4H', 'T', 'Y', '7d', '30d']"
  [isLoading]="isLoading"
  (refresh)="refresh()"
  (onPeriodEmitted)="onPeriodEmitted($event)"
  [datePickerSlug]="'dashboard'"
/>
@if (!isNewOrga) {
  <div *featureFlag="'dashboardQueryParams'" class="row space-between-filter">
    <app-filters
      #filtersComponent
      (filtersEmitter)="onFiltersChange($event)"
      [filtersInput]="filters"
      [isLoading]="isLoading"
    ></app-filters>
    <a (click)="toPrint()" *ngIf="isPrintable; else noPrint" class="ogo-link">
      {{ 'PrintThisReport' | translate }}
    </a>
    <ng-template #noPrint>&nbsp;</ng-template>
  </div>

  <div *notFeatureFlag="'dashboardQueryParams'" class="row to-right">
    <a (click)="toPrint()" *ngIf="isPrintable; else noPrintAlt" class="ogo-link">
      {{ 'PrintThisReport' | translate }}
    </a>
    <ng-template #noPrintAlt>&nbsp;</ng-template>
  </div>
}

<div *ngIf="isNewOrga" class="bg-blue new-site">
  {{ 'WelcomeOgo' | translate }}&nbsp;
  <a [routerLink]="['/' + MY_SITES_ROUTE + '/' + ADD_ROUTE]" class="new-site-link">{{ 'AjouterUnSite' | translate }}</a>
  {{ 'ToStart' | translate }}
</div>

<div class="row">
  <app-dashboard-card
    class="col-md-6 col-xl-3"
    bgColor="bg-c-pink"
    [title]="'Bloquees' | translate"
    (clickTitle)="navigateToLogsFilteredByAction(ActionEnum.BLOCKED)"
    (selectSite)="selectSite($event)"
    [total]="totals?.blocked"
    [breakdown]="breakdown?.blocked"
    [isLoading]="isLoading"
  />

  <app-dashboard-card
    class="col-md-6 col-xl-3"
    bgColor="bg-c-suspect"
    [title]="'Suspectes' | translate"
    (clickTitle)="navigateToLogsFilteredByAction(ActionEnum.SUSPICIOUS)"
    (selectSite)="selectSite($event)"
    [total]="totals?.suspect"
    [breakdown]="breakdown?.suspect"
    [isLoading]="isLoading"
  />

  <app-dashboard-card
    class="col-md-6 col-xl-3"
    bgColor="bg-c-robot"
    [title]="'Robots' | translate"
    (selectSite)="selectSite($event)"
    [total]="totals?.robot"
    [breakdown]="breakdown?.robot"
    [isLoading]="isLoading"
  />

  <app-dashboard-card
    class="col-md-6 col-xl-3"
    bgColor="bg-c-green"
    [title]="'Analysees' | translate"
    (clickTitle)="navigateToLogs({})"
    (selectSite)="selectSite($event)"
    [total]="totals?.analyzed"
    [breakdown]="breakdown?.analyzed"
    [isLoading]="isLoading"
  />

  <div id="attacks-donut" class="col-xl-6">
    <div class="card" style="min-height: 400px">
      @if (isLoading) {
        <ogo-spinner [inline]="true" [margin]="'7rem 0'"></ogo-spinner>
      } @else {
        <app-donut
          [data]="blockAttack"
          [title]="'TypesAttaques' | translate"
          (sliceClicked)="onAttackCategoryClick($event)"
        />
      }
    </div>
  </div>

  <div id="trafic-graph" class="col-xl-6">
    <div class="card" style="min-height: 400px">
      @if (isLoading) {
        <ogo-spinner [inline]="true" [margin]="'7rem 0'"></ogo-spinner>
      } @else {
        @if(chartInterval) {
          <div class="chart-interval">{{ 'Graph.interval' | translateLabel }} {{ chartInterval | durationSeconds }}</div>
        }
        <app-graph
          [data]="audience"
          [title]="'AnalyseTrafic' | translate"
          (zoneSelected)="onPeriodEmittedFromZoneSelected($event)"
        />
      }
    </div>
  </div>

  <div class="col-md-12 world-map">
    <div class="card">
      <div class="btn-group" role="group">
        <button
          (click)="changeOrigine('traffic')"
          type="button"
          class="btn btn-square"
          [class.btn-inverse]="originSelected == 'traffic'"
        >
          {{ 'Requests' | translate }}
        </button>
        <button
          (click)="changeOrigine('robot')"
          type="button"
          class="btn btn-square"
          [class.btn-inverse]="originSelected == 'robot'"
        >
          {{ 'Robots' | translate }}
        </button>
        <button
          (click)="changeOrigine('blockedByBrain')"
          type="button"
          class="btn btn-square"
          [class.btn-inverse]="originSelected == 'blockedByBrain'"
        >
          {{ 'RequetesBloqueesByAI' | translate }}
        </button>
        <button
          (click)="changeOrigine(BLOCKED_COUNTRY)"
          type="button"
          class="btn btn-square"
          [class.btn-inverse]="originSelected == BLOCKED_COUNTRY"
        >
          {{ 'Blocked Countries' | translate }}
        </button>
      </div>
      <app-world-map
        [titleKey]="'Origins.title.' + originSelected"
        [seriesNameKey]="'Graph.seriesName.' + originSelected"
        [data]="countryDatas ? countryDatas[originSelected] : null"
        [height]="'700px'"
        [colorStops]="MAP_COLOR_STOPS[originSelected]"
        (countryClick)="onCountryClick(originSelected, $event)"
        class="app-world-map"
      />
    </div>
  </div>

  <div class="col-md-12" *ngIf="isAdminClusterView ? isASiteSelected : true">
    <div
      class="btn-group tabs-over-graph tabs-dashboard-tables"
      data-original-title=".btn-xlg"
      data-placement="top"
      data-toggle="tooltip"
      role="group"
      title=""
    >
      <button
        (click)="selectTable(Table.TOP_BLOCKED_IPS)"
        class="btn waves-effect waves-light"
        [ngClass]="{ 'btn-inverse': pageSelected == Table.TOP_BLOCKED_IPS }"
        type="button"
        [innerHTML]="'topBlockedIps' | translate"
      ></button>
      <button
        (click)="selectTable(Table.SLOW_REQUESTS)"
        class="btn waves-effect waves-light"
        [ngClass]="{ 'btn-inverse': pageSelected == Table.SLOW_REQUESTS }"
        type="button"
        [innerHTML]="'RequetesLentes' | translate"
      ></button>
      <button
        (click)="selectTable(Table.CPU_CONSUMING_REQUESTS)"
        class="btn waves-effect waves-light"
        [ngClass]="{ 'btn-inverse': pageSelected == Table.CPU_CONSUMING_REQUESTS }"
        type="button"
        [innerHTML]="'PagesPlusVisitees' | translate"
      ></button>
    </div>
    <div class="card with-tabs">
      <div *ngIf="!isTableLoading; else loader">
        <ng-container [ngSwitch]="pageSelected">
          <ng-container *ngSwitchCase="Table.TOP_BLOCKED_IPS">
            <app-blocked-ips-table
              [topBlockedIps]="topBlockedIps"
              (clickCountry)="navigateToLogsFilteredByCountry($event)"
              (clickIp)="navigateToLogsFilteredByIp($event)"
            />
          </ng-container>

          <ng-container *ngSwitchCase="Table.SLOW_REQUESTS">
            <app-slow-requests-table [slowRequests]="slowRequests" (clickPath)="clickSlowRequestPath($event)" />
          </ng-container>

          <ng-container *ngSwitchCase="Table.CPU_CONSUMING_REQUESTS">
            <app-most-frequent-requests-table
              [cpuConsumingRequests]="cpuConsumingRequests"
              (clickPath)="clickFrequentRequestPath($event)"
            />
          </ng-container>
        </ng-container>
      </div>
      <ng-template #loader>
        <div class="component-loader">
          <div class="loader-track">
            <div class="loader-bar"></div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
